var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"页面未找到"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }